import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";

export default createStore({
  state() {
    return {
      pdfFile: null, // 不持久化
      pdf_preview_imageUrl: null, // 需要持久化
      taskId: null, // 需要持久化
      pdf_title: null, // 需要持久化
      word_preview_imageUrl: null, // 需要持久化
    };
  },
  mutations: {
    setPdfFile(state, file) {
      state.pdfFile = file;
    },
    deletePdfFile(state) {
      state.pdfFile = null;
    },
    setPdfPreviewImageUrl(state, url) {
      state.pdf_preview_imageUrl = url;
    },
    setWordPreviewImageUrl(state, url) {
      state.word_preview_imageUrl = url;
    },
    setTaskId(state, id) {
      state.taskId = id;
    },
    setPdfTitle(state, title) {
      state.pdf_title = title;
    },
    clearData(state) {
      state.pdf_preview_imageUrl = null;
      state.word_preview_imageUrl = null;
      state.taskId = null;
      state.pdf_title = null;
    },
  },
  actions: {
    uploadPdfFile({ commit }, file) {
      commit("setPdfFile", file);
    },
    deletePdfFile({ commit }) {
      commit("deletePdfFile");
    },
    uploadPdfPreviewImage({ commit }, url) {
      commit("setPdfPreviewImageUrl", url);
    },
    uploadWordPreviewImage({ commit }, url) {
      commit("setWordPreviewImageUrl", url);
    },
    generateTaskId({ commit }, id) {
      commit("setTaskId", id);
    },
    generatePdfTitle({ commit }, title) {
      commit("setPdfTitle", title);
    },
    clearStore({ commit }) {
      commit("clearData");
    },
  },
  getters: {
    getPdfFile: (state) => state.pdfFile,
    getPdfPreviewImageUrl: (state) => state.pdf_preview_imageUrl,
    getWordPreviewImageUrl: (state) => state.word_preview_imageUrl,
    getTaskId: (state) => state.taskId,
    getPdfTitle: (state) => state.pdf_title,
  },
  plugins: [
    createPersistedState({
      paths: ["pdf_preview_imageUrl", "taskId", "pdf_title", "word_preview_imageUrl"], // 持久化 pdf_preview_imageUrl, taskId, pdf_title, word_preview_imageUrl
    }),
  ],
});
